import styled from 'styled-components';

import { FlexBoxCol } from '@r1-frontend/ui-react/components/layouts/flexBoxGrid';
import { mobileFirstBreakpoints, wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BlockContainer } from '@r1-frontend/ui-react/experimental/containers';

export const SBlockContainer = styled(BlockContainer)<{hasNegativeMarginTop: boolean}>`
    border-radius: 32px 32px 0 0;
    margin-bottom: -50px;
    margin-top: ${({ hasNegativeMarginTop }) => hasNegativeMarginTop && -32 + 'px'};
`;

export const Col = styled(FlexBoxCol)`
    & > div:not(:last-of-type) {
        margin-bottom: 32px;

        @media (max-width: ${wideBreakpoints.laptop}) {
            margin-bottom: 24px;
        }
    }

    @media (max-width: ${wideBreakpoints.tablet}) and (min-width: ${mobileFirstBreakpoints.mobile}) {
        display: flex;
        flex-direction: column;
    }
`;
